/* eslint-disable react/display-name */
import React from 'react'
import Highlight, { defaultProps } from 'prism-react-renderer'
import Prism from 'prism-react-renderer/prism'
import theme from 'prism-react-renderer/themes/vsDark'

import './code-blocks.css'
import { CopyButton } from '..'
import { CopyPasteIcon, SuccessCheckIcon } from '../../icons'
import { copyToClipboard } from '../../../utils'
import withAnalytics from '../../../utils/withAnalytics'

const CodeBlock = ({ children, className, fpti }: any) => {
  const [isCopied, setIsCopied] = React.useState(false)
  const language = className && className.replace(/language-/, '')
  const fptiData = typeof window !== `undefined` && window.fpti
  const gaData = typeof window !== `undefined` && window.ga

  const handleCopyClipboard = (isButton = false) => {
    if (isButton) {
      copyToClipboard(children)
    }
    setIsCopied(true)
    setTimeout(() => setIsCopied(false), 3000)

    if (fptiData) {
      const options = {
        data: {
          page: fptiData.page,
          pgrp: fptiData.pgrp,
          e: 'cl',
          link: 'copy-content',
          component: 'devdiscoverynodeweb',
        },
      }

      if (window.PAYPAL?.analytics?.instance) {
        window.PAYPAL?.analytics?.instance?.record(options)
      }
    }

    if (gaData) {
      gaData('send', 'event', {
        eventCategory: 'codeblock',
        eventAction: 'click',
        eventLabel: 'copyContent',
      })
    }
  }

  ;(typeof global !== 'undefined' ? global : window).Prism = Prism
  require('prismjs/components/prism-php')
  require('prismjs/components/prism-java')
  require('prismjs/components/prism-ruby')
  require('prismjs/components/prism-aspnet')
  require('prismjs/components/prism-csharp')
  require('prismjs/components/prism-kotlin')

  return (
    <div onCopy={() => handleCopyClipboard()}>
      <Highlight
        {...defaultProps}
        theme={theme}
        code={children.trim()}
        language={language}
      >
        {({ className, style, tokens, getLineProps, getTokenProps }) => {
          return (
            <>
              <div className="copyBtn-wrapper">
                <CopyButton onClick={() => handleCopyClipboard(true)}>
                  {isCopied ? <SuccessCheckIcon /> : <CopyPasteIcon />}
                </CopyButton>
              </div>
              <pre
                className={`${className} noHighlight`}
                style={{
                  ...style,
                  background: '#1e204c',
                  border: 0,
                  borderRadius: '0.5rem',
                  color: '#eee',
                  position: 'relative',
                  padding: '0 1.5rem 1.5rem',
                  fontSize: '0.9375rem',
                  marginTop: '0',
                }}
              >
                {tokens.map((line, i) => (
                  <div
                    key={i}
                    {...getLineProps({ line, key: i })}
                    className="line"
                  >
                    <span className="line-number">{i + 1}</span>
                    <span className="line-content">
                      {line.map((token, key) => (
                        <span key={key} {...getTokenProps({ token, key })} />
                      ))}
                    </span>
                  </div>
                ))}
              </pre>
            </>
          )
        }}
      </Highlight>
    </div>
  )
}

export default withAnalytics(CodeBlock)
